import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import * as auth from '../../../store/actions/auth';
import { UserActions } from '../../../store/actions/users';

import './styles.scss';

import ModalMfa from './ModalMfa';

// import { faTaxi } from '@fortawesome/free-solid-svg-icons';

export default function MultiFactorAuth() {
  const users = useSelector((state) => state.users.signedUser);

  const dispatch = useDispatch();

  const [isActiveModal, setIsActiveModal] = useState(false);

  useEffect(() => {
    if (!users) {
      dispatch(UserActions.me());
    }
  }, [users]);

  const handlerCloseModal = () => {
    setIsActiveModal(false);
  };

  const handleToggleActived = () => {
    if (users?.tfa?.active) {
      dispatch(auth?.tfaDisable());
    } else {
      setIsActiveModal(true);
    }
  };

  return (
    <>
      <div className="container-mfa">
        <h5>Autenticação de 2 Fatores</h5>
        <p>
          Cada vez que você entrar em sua conta, você precisará de sua senha e
          código de verificação.
        </p>
        <div className="divider" />
        <h6>Google Authenticator</h6>
        <p>
          Use o aplicativo Google Authenticator para gerar códigos de segurança
          únicos.
        </p>
        <button
          onClick={handleToggleActived}
          type="button"
          className={`btn btn-outline-${
            !users?.tfa?.active ? 'success' : 'danger'
          }`}
        >
          {!users?.tfa?.active ? 'Ativar' : 'Desativar'}
        </button>
      </div>
      <ModalMfa isActive={isActiveModal} closeModal={handlerCloseModal} />
    </>
  );
}
